// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  position: 'relative',
  display: 'flex',
  flexFlow: 'column nowrap',
  minWidth: '250px',
  height: '100%',
})

export const Footer = styled<{}>('div', ({ $palette }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  borderTop: `1px solid ${$palette('gray')}`,
  padding: '10px',
  flexShrink: 0,
}))

export const TimeFieldWrapper = styled<{}>('div', ({ $palette }) => ({
  borderBottom: `1px solid ${$palette('gray')}`,
}))

export const InputContainer = styled('div', {
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  maxWidth: '100%',
})
